import React from "react"
import { Button, Card, CardBody, Table } from "reactstrap"
import { useTranslation } from "react-i18next"
import { Check, Eye, TimerReset } from "lucide-react"

import Paginations from "components/Common/Pagination"
import NoDataAvailable from "components/Shared/NoDataAvailable"
import { useDispatch } from "react-redux"
import { showAlert } from "store/reducers/alertReducer"
import {
  allowSigningContractsForSingleCandidate,
  resetContract,
} from "store/actions/contractsAction"

const CandidatesDataTable = ({
  currentPage,
  totalPages,
  totalCount,
  onPageChange,
  loading,
  data = [],
  payload,
  activeTab,
  trigger,
  showAll,
  permissions,
}) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const headers = [
    "S. No.",
    "National Id",
    "Full Name",
    "Phone Number",
    "Job Title",
    ...(activeTab === "all" ? ["Status"] : []),
    ...(activeTab === "rejected" ? ["Rejection Reason"] : []),
    "Action",
  ]

  const status = {
    0: "Not Generated",
    1: "Not Signed",
    2: "Signed",
    3: "Rejected",
  }

  const handleAllowContractSign = uuid => {
    dispatch(allowSigningContractsForSingleCandidate({ contract_uuid: uuid }))
      .then(action => {
        const { statusCode, success, message } = action?.payload
        if (statusCode === 200 && success) {
          dispatch(showAlert({ text: message, type: "success" }))
          trigger()
        } else {
          dispatch(showAlert({ text: message, type: "error" }))
        }
      })
      .catch(err => {})
  }

  const handleResetContract = uuid => {
    dispatch(resetContract({ contract_uuid: uuid }))
      .then(action => {
        const { statusCode, success, message } = action?.payload
        if (statusCode === 200 && success) {
          dispatch(showAlert({ text: message, type: "success" }))
          trigger()
        } else {
          dispatch(showAlert({ text: message, type: "error" }))
        }
      })
      .catch(err => {})
  }

  return (
    <>
      <Card className="user_personal_info theme_card overflow-x-auto">
        <CardBody>
          <div className="table-responsive">
            <Table className="table mb-0">
              <thead className="table-light full_th">
                <tr>
                  {headers.map((item, index) => (
                    <th key={index}>{t(item)}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {data.map((item, index) => (
                  <tr key={index}>
                    <th scope="row">
                      {(currentPage - 1) * (payload?.limit || 50) + index + 1}
                    </th>
                    <td>{item.user_national_id}</td>
                    <td>{item.user_full_name}</td>

                    <td>{item.user_phone_number}</td>
                    <td>{item.user_job_title || "-"}</td>
                    {activeTab === "rejected" && <td>{item.reject_reason}</td>}
                    {activeTab === "all" && <td>{t(status[item.status])}</td>}
                    <td title={t("View Contract")}>
                      <div className="d-flex gap-2 align-items-center ">
                        <Eye
                          className="cursor-pointer text-primary"
                          onClick={() =>
                            window.open(item.contract_file_path, "_blank")
                          }
                        />
                        {activeTab === "all" &&
                          item.status === 0 &&
                          (showAll ||
                            permissions.includes(
                              "can_allow_single_signing_of_contract"
                            )) && (
                            <Button
                              color="primary"
                              title={t("Allow Contract Sign")}
                              onClick={() => handleAllowContractSign(item.uuid)}
                            >
                              <Check size={12} />
                            </Button>
                          )}
                        {activeTab === "rejected" &&
                          (showAll ||
                            permissions.includes("can_reset_contract")) && (
                            <Button
                              color="primary"
                              title={t("Reset Contract")}
                              onClick={() => handleResetContract(item.uuid)}
                            >
                              <TimerReset size={12} />
                            </Button>
                          )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </CardBody>
      </Card>
      {!loading && data.length === 0 && <NoDataAvailable />}
      {!loading && data.length > 0 && (
        <Paginations
          currentPage={currentPage}
          totalPages={totalPages}
          totalCount={totalCount}
          onPageChange={onPageChange}
        />
      )}
    </>
  )
}

export default CandidatesDataTable
